import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { UtilityFunctions } from '../../utilities/utility-functions';
import { UserSession } from '../../interfaces/user-session';
import { Telemetrigram } from '../../models/data/operations/telemetrigram';

@Injectable({
    providedIn: 'root'
})

export class TelemetryService {

    private _apiBaseUrl: string = "";

    public constructor(private http: HttpClient, @Inject("API_BASE_URL") apiBaseUrl: string) {

        this._apiBaseUrl = apiBaseUrl;
    }

    public createTelemetrigram = (request: Telemetrigram): Observable<any> => {

        let result: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
        const apiPath: string = "telemetry/create";
        const fullPath: string = this._apiBaseUrl + apiPath;
        let httpOptions: any = null;

        const loggedUserSession: any = UtilityFunctions.getUserSession(); // localStorage.getItem("userSession");

        if (loggedUserSession) {

            const userSession: UserSession = JSON.parse(loggedUserSession);
            let authorizationHeaderValue: string = "Bearer " + userSession.bearerToken;

            httpOptions = { headers: new HttpHeaders({ "content-type": "application/json", "Authorization": authorizationHeaderValue }) };

        } else {

            httpOptions = { headers: new HttpHeaders({ "content-type": "application/json" }) };
        }

        this.http.post<any>(fullPath, request, httpOptions).subscribe((settings: any) => {

            result.next(settings);
            result.complete();

        }, error => {

            result.next(error);
        });

        return result;
    }
}
